<template>
  <b-card class="card-primary-header">
    <div slot="header">
      <div>
        Viðvera
        <a @click.prevent="registerAttendanceModal()">
          <i class="fa fa-fw fa-plus" style="font-size: 20px; float: right; padding-top: 5px"></i>
        </a>
      </div>
    </div>
    <div class="equal-height-3">
      <div v-if="!loggedInUserHasAnyPermission('read_attendance')">
        <i>Þú hefur ekki aðgang að því að skoða viðveru</i>
      </div>
      <div v-else>
        <table class="table white-table mb-0" v-if="data.length > 0">
          <tr>
            <td colspan="8">
              <i
                >Heildarfjöldi tíma fyrir alla hópa á tímabilinu: <b>{{ periodTotalHours }}</b>
                <span
                  v-if="periodHoursGroups && periodHoursGroups.length > 0"
                  class="fa fa-fw fa-info-circle ml-1"
                  v-b-tooltip.hover
                  :title="`Hópar: ${periodHoursGroups.join(', ')}`"
                ></span>
              </i>
              <i v-if="periodMaxHours" class="ml-3"
                >Hámarks vinnustundir á tímabili: <b>{{ Number(periodMaxHours) }}</b></i
              >
            </td>
          </tr>
          <tr>
            <th>Dags</th>
            <th>Fj. klst.</th>
            <th>Veikindi (klst.)</th>
            <th v-if="projectList.length > 0">Verkefni</th>
            <th>Fjarvist</th>
            <th>Athugasemd</th>
            <th></th>
            <th></th>
          </tr>
          <tr v-for="attendance in data" :key="attendance.id">
            <td>
              {{ attendance.date | moment('DD.MM.YYYY') }}
              <span v-if="attendance.correction" class="badge badge-correction ml-1">Leiðrétting</span>
            </td>
            <td>
              <span v-if="!attendance.hours"><i>Ekki skráð</i></span>
              <span v-else>{{ attendance.hours }}</span>
            </td>
            <td>
              <span v-if="attendance.sick_hours > 0">{{ attendance.sick_hours }}</span>
            </td>
            <td v-if="projectList.length > 0">
              {{ attendance.attendance_project ? attendance.attendance_project.name : '' }}
            </td>
            <td>
              {{ attendance.attendance_type ? attendance.attendance_type.name : '' }}
            </td>
            <td>
              <span v-b-tooltip.hover :title="attendance.comment">{{ attendance.comment | limitTo(20) }}</span>
            </td>
            <td>
              <i
                v-if="attendance.created_by_registration"
                class="fa fa-info-circle"
                style="color: #008ad0"
                v-b-tooltip.hover
                title="Skráð af aðstandanda á umsóknarvef"
              ></i>
            </td>
            <td>
              <a
                v-if="loggedInUserHasAnyPermission('write_attendance') && !attendance.correction"
                @click.prevent="editAttendanceRow(attendance)"
                style="cursor: pointer"
              >
                <i class="fa fa-fw fa-pencil"></i>
              </a>
            </td>
          </tr>
        </table>

        <div v-else><i>Engin viðvera skráð</i></div>
      </div>
    </div>
    <div class="px-4">
      <pagination
        v-if="pagination && data && data.length > 0"
        :pagination-response="pagination"
        @change-limit="changeLimit"
        @change-page="changePage"
      >
      </pagination>
    </div>
    <attendance-edit-modal ref="editModal" @successful="loadList()"></attendance-edit-modal>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import attendance from '@/api/attendance';
import Pagination from '@/components/Pagination.vue';
import { parsePagination } from '@/utils';
import AttendanceEditModal from '@/components/attendance/AttendanceEditModal.vue';

export default {
  name: 'student-attendance',
  props: ['reload', 'item', 'personName', 'periodMaxHours', 'periodTotalHours', 'periodHoursGroups'],
  components: {
    Pagination,
    AttendanceEditModal,
  },
  computed: {
    ...mapGetters(['loggedInUserHasAnyPermission']),
  },
  data() {
    return {
      pagination: null,
      loading: false,
      data: [],
      projectList: [],
    };
  },
  methods: {
    async loadList(page, limit) {
      this.data = [];
      if (this.loggedInUserHasAnyPermission('read_attendance') && this.item) {
        this.loading = true;
        try {
          const response = await attendance.attendanceList(page || undefined, limit || 5, this.item.id);
          this.data = response.data;
          this.pagination = parsePagination(response);
          this.$nextTick(() => {
            document.dispatchEvent(new CustomEvent('matchheight', {}));
          });
        } catch (e) {
          this.$log.error(e);
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        } finally {
          this.loading = false;
        }
      }
    },
    async loadProjects() {
      if (!this.loggedInUserHasAnyPermission('read_attendance')) return;
      try {
        const response = await attendance.attendanceOverviewProjectList();
        this.projectList = response.data;
      } catch (e) {
        this.$log.error(e);
      }
    },
    changeLimit(limit) {
      this.loadList(undefined, limit);
    },
    changePage(page) {
      this.loadList(page, this.pagination.currentLimit);
    },
    registerAttendanceModal() {
      this.$refs.editModal.show({
        personId: this.item.id,
        personName: this.personName,
        groupId: this.item.placement_group.id,
        attendanceId: null,
        date: null,
        dateFrom: this.item.placement_group.date_from,
        dateTo: this.item.placement_group.date_to,
        hours: '',
        sick_hours: '',
        projectId: null,
        absenceTypeId: null,
        comment: '',
        maxHours: null,
        batch: false,
      });
    },
    editAttendanceRow(att) {
      this.$refs.editModal.show({
        personId: this.item.id,
        personName: this.personName,
        groupId: this.item.placement_group.id,
        attendanceId: att.id,
        date: att.date,
        dateFrom: null,
        dateTo: null,
        hours: att.hours != null ? String(att.hours) : '',
        sick_hours: att.sick_hours != null ? String(att.sick_hours) : '',
        projectId: att.attendance_project ? att.attendance_project.id : null,
        absenceTypeId: att.attendance_type ? att.attendance_type.id : null,
        comment: att.comment || '',
        maxHours: null,
        batch: !!att.correction,
      });
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  watch: {
    reload(val) {
      if (val) {
        this.loadList();
      }
    },
  },
  created() {
    this.loadList();
    this.loadProjects();
  },
};
</script>
